import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import {
  CommonLayout,
  StyledContentContainer,
  StyledTitle,
  StyledText,
  StyledLink,
  StyledButton,
} from '@selfserve/react-ui';
import { buttonIds, links, routesPaths } from '@selfserve/react-utils';

const StyledLinkUsedText = styled(StyledText)`
  max-width: 410px;
  margin: 24px 0;
`;

export const LinkUsed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onChoosePlanClickHandle = useCallback(() => {
    window.location.href = links.PRICING;
  }, []);

  const onLogInClickHandle = useCallback(() => {
    navigate(routesPaths.LOGIN);
  }, []);

  return (
    <CommonLayout showSideImage>
      <StyledContentContainer centered>
        <StyledTitle as="span" className="main-header">
          {t('common.link-used')}
        </StyledTitle>
        <StyledLinkUsedText className="verify-description" centered>
          <StyledLink
            to=""
            onClick={onChoosePlanClickHandle}
            id={buttonIds.resendVerification}
          >
            {t('common.choose-plan')}
          </StyledLink>
          {` ${t('common.link-used-content')}`}
        </StyledLinkUsedText>
        <StyledButton onClick={onLogInClickHandle}>
          {t('common.login')}
        </StyledButton>
      </StyledContentContainer>
    </CommonLayout>
  );
};
